import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import RegistrationCitizenshipNotificationShared from 'shell/components/shared/research-notifications/research-citizenship/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface RegistrationCitizenshipAnscNotificationsSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const RegistrationCitizenshipAnscNotificationsShared = ({
  scope,
  items,
}: RegistrationCitizenshipAnscNotificationsSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <RegistrationCitizenshipNotificationShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
      />
    </Fragment>
  );
};

RegistrationCitizenshipAnscNotificationsShared.displayName =
  'Registration Citizenship Notification Page component';

export default RegistrationCitizenshipAnscNotificationsShared;
